import React from 'react';
import {classes} from './CheckoutButton.st.css';
import classnames from 'clsx';
import {useControllerProps} from '../../../domain/controllers/ControllerContext';
import {Button, ButtonPriority} from '@wix/wix-ui-tpa/cssVars';
import {SECURE_CHECKOUT_ID} from '../SecureCheckout/SecureCheckout';
import {useExperiments} from '@wix/yoshi-flow-editor';
import {SPECS} from '../../../domain/specs';

export enum CheckoutButtonDataHook {
  button = 'CheckoutButtonDataHook.button',
}

export interface CheckoutButtonProps {
  disabled?: boolean;
  priority?: ButtonPriority;
  text: string;
  className?: string;
}

export function CheckoutButton({disabled, priority, text, className}: CheckoutButtonProps) {
  const {handleCheckoutButtonHover, checkoutUrl, handleCheckoutButtonClick} = useControllerProps().navigationStore;
  const {experiments} = useExperiments();
  const ariaLabelProps = experiments.enabled(SPECS.FixCheckoutButtonAriaLabel)
    ? {'aria-label': text}
    : {'aria-labelledby': SECURE_CHECKOUT_ID};

  const onClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
    return handleCheckoutButtonClick();
  };

  return (
    <Button
      href={disabled ? undefined : checkoutUrl?.url}
      as="a"
      priority={priority}
      {...ariaLabelProps}
      className={classnames(classes.customizableCheckoutButton, disabled && classes.buttonDisabled, className)}
      data-hook={CheckoutButtonDataHook.button}
      data-wix-checkout-button={CheckoutButtonDataHook.button}
      onClick={onClick}
      onMouseEnter={() => handleCheckoutButtonHover()}
      disabled={disabled}
      upgrade>
      {text}
    </Button>
  );
}
